import React from "react";

export default function AnalogClock({ time, fullscreen }) {
    const hours = time.getHours() % 12;
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();

    // Calculate angles (0 degrees = 12 o'clock)
    const secondAngle = (seconds * 6); // 360/60 = 6 degrees per second
    const minuteAngle = (minutes * 6) + (seconds * 0.1); // 6 degrees per minute + smooth transition
    const hourAngle = (hours * 30) + (minutes * 0.5); // 30 degrees per hour + smooth transition

    const clockNumbers = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    return (
        <div className="flex justify-center">
            <svg
                viewBox="0 0 200 200"
                className={`w-full ${fullscreen ? "max-w-[70vh]" : "max-w-xs sm:max-w-sm"}`}
                aria-label={`Horloge analogique montrant ${String(time.getHours()).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`}
                role="img"
            >
                {/* Clock face */}
                <circle
                    cx="100"
                    cy="100"
                    r="95"
                    fill="white"
                    stroke="#374151"
                    strokeWidth="2"
                />

                {/* Hour markers */}
                {[...Array(12)].map((_, i) => {
                    const angle = (i * 30 * Math.PI) / 180;
                    const x1 = 100 + 85 * Math.sin(angle);
                    const y1 = 100 - 85 * Math.cos(angle);
                    const x2 = 100 + 75 * Math.sin(angle);
                    const y2 = 100 - 75 * Math.cos(angle);
                    return (
                        <line
                            key={i}
                            x1={x1}
                            y1={y1}
                            x2={x2}
                            y2={y2}
                            stroke="#374151"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    );
                })}

                {/* Numbers */}
                {clockNumbers.map((num, i) => {
                    const angle = (i * 30 * Math.PI) / 180;
                    const x = 100 + 65 * Math.sin(angle);
                    const y = 100 - 65 * Math.cos(angle);
                    return (
                        <text
                            key={num}
                            x={x}
                            y={y}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            className="font-mono text-xs font-semibold fill-gray-700"
                            fontSize="12"
                        >
                            {num}
                        </text>
                    );
                })}

                {/* Hour hand */}
                <line
                    x1="100"
                    y1="100"
                    x2={100 + 40 * Math.sin((hourAngle * Math.PI) / 180)}
                    y2={100 - 40 * Math.cos((hourAngle * Math.PI) / 180)}
                    stroke="#1f2937"
                    strokeWidth="6"
                    strokeLinecap="round"
                    style={{ transition: "all 0.5s ease-in-out" }}
                />

                {/* Minute hand */}
                <line
                    x1="100"
                    y1="100"
                    x2={100 + 60 * Math.sin((minuteAngle * Math.PI) / 180)}
                    y2={100 - 60 * Math.cos((minuteAngle * Math.PI) / 180)}
                    stroke="#374151"
                    strokeWidth="4"
                    strokeLinecap="round"
                    style={{ transition: "all 0.5s ease-in-out" }}
                />

                {/* Second hand */}
                <line
                    x1="100"
                    y1="100"
                    x2={100 + 70 * Math.sin((secondAngle * Math.PI) / 180)}
                    y2={100 - 70 * Math.cos((secondAngle * Math.PI) / 180)}
                    stroke="#ef4444"
                    strokeWidth="2"
                    strokeLinecap="round"
                />

                {/* Center dot */}
                <circle cx="100" cy="100" r="5" fill="#1f2937" />
            </svg>
        </div>
    );
}
